import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { stageBadgeClass, stageLabel, stateBadgeClass, stateLabel } from './waStageLabels';

export default function WaSessionsTable({ sessions, loading, onSelect, onHandoff }) {
  if (loading) {
    return <p className="p-6 text-center text-gray-500 text-sm">Loading sessions…</p>;
  }
  if (!sessions?.length) {
    return <p className="p-6 text-center text-gray-500 text-sm">No active sessions</p>;
  }
  return (
  <>
    <div className="hidden md:block overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 text-left">
          <tr>
            <th className="p-3">Phone</th>
            <th className="p-3">Customer</th>
            <th className="p-3">Stage</th>
            <th className="p-3">Route</th>
            <th className="p-3">Updated</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((row) => (
            <tr key={row.id} className="border-t hover:bg-gray-50">
              <td className="p-3 font-mono text-xs">{row.phone_masked}</td>
              <td className="p-3">{row.customer_name}</td>
              <td className="p-3">
                <span className={`text-xs px-2 py-0.5 rounded-full ${stageBadgeClass(row.stage)}`}>
                  {stageLabel(row.stage)}
                </span>
              </td>
              <td className="p-3">{row.route || '—'}</td>
              <td className="p-3 text-gray-500 text-xs">
                {row.updated_at ? formatDistanceToNow(new Date(row.updated_at), { addSuffix: true }) : '—'}
              </td>
              <td className="p-3 space-x-2">
                <button type="button" className="text-xs text-[#659A9B]" onClick={() => onSelect?.(row.id)}>
                  Details
                </button>
                <button type="button" className="text-xs text-red-600" onClick={() => onHandoff?.(row.id)}>
                  Handoff
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="md:hidden divide-y">
      {sessions.map((row) => (
        <div key={row.id} className="p-4">
          <p className="font-mono text-xs">{row.phone_masked}</p>
          <p className="font-medium">{row.customer_name}</p>
          <p className="text-xs text-gray-500 mt-1">{row.route || '—'}</p>
          <div className="flex gap-2 mt-2">
            <button type="button" className="text-xs text-[#659A9B]" onClick={() => onSelect?.(row.id)}>Details</button>
            <button type="button" className="text-xs text-red-600" onClick={() => onHandoff?.(row.id)}>Handoff</button>
          </div>
        </div>
      ))}
    </div>
  </>
  );
}
